import styled from 'styled-components';

export const ObligationCardWrapper = styled.div`
  position: absolute;
  left: ${(props) => ((props?.timeFromInteger - props?.shiftTimeFrom - props?.leftModified + props?.positionModified) * props?.hoursCellWidth)}px;
  right: ${(props) => (props?.shiftTimeTo - props?.timeToInteger - props?.rightModified - props?.positionModified) * props?.hoursCellWidth}px;
  width: auto;
  height: 100%;
  max-width: 100%;
  opacity: ${(props) => (props?.isDragging ? '0.6' : '1')};
  // background-color: ${(props) => (props?.sectorRoleShortName === 'EXE' ? '#78D59A' : (props?.sectorRoleShortName === 'PLC' ? '#cdb1ca' : 'gray'))};
  background-color: ${(props) => {
    switch (props?.sectorName) {
      case 'L':
      case 'LU':
        return '#78D59A'; // GREEN
      case 'U':
        return '#FFC067'; // ORANGE
      case 'H':
      case 'HT':
      case 'UHT':
      case 'LUHT':
      case 'LUHTS':
      case 'HTS':
      case 'UHTS':
        return '#FF9E99'; // RED
      case 'T':
      case 'TS':
        return '#8FD9FB'; // BLUE
      case 'S':
        return '#FFEE8C'; // YELLOW
      case 'FMP':
      case 'ŠS':
      case 'ŠS/FMP':
      case 'SATCO':
        return '#cdb1ca';
      case 'SB':
        return 'gray';
      default:
        return 'gray';
    }
  }};
  border-radius: 5px;
  border: ${(props) => (props?.modified ? '2px solid rgba(219,90,81)' : '1px solid #a3a3a3')};
  z-index: ${(props) => (props?.isDragging ? '999' : 'auto')};
  box-sizing: border-box;
  transition: 0.5s background-color;
  cursor: ${(props) => (props?.sliding ? 'w-resize' : (props?.isDragging ? 'grabbing' : (props?.editModeOn ? 'grab' : 'pointer')))};
  display: flex;
  flex-direction: column;
  justify-content: center;
  filter: ${(props) => (props?.sliding || props?.isDragging ? 'brightness(120%)' : '')};
  -webkit-filter: ${(props) => (props?.sliding || props?.isDragging ? 'brightness(110%)' : '')};
  -moz-filter: ${(props) => (props?.sliding || props?.isDragging ? 'brightness(110%)' : '')};
  overflow: hidden;
  &:hover {
    filter: ${(props) => (props?.editModeOn ? 'brightness(120%)' : '')};
    -webkit-filter: ${(props) => (props?.editModeOn ? 'brightness(110%)' : '')};;
    -moz-filter: ${(props) => (props?.editModeOn ? 'brightness(110%)' : '')};
  }
`;

export const LeftResizeBox = styled.div`
  height: 35px;
  width: 5px;
  position: absolute;
  left: 0;
  cursor: ${(props) => (props?.editModeOn ? 'w-resize' : 'pointer')};
  background-color: ${(props) => (props?.sliding ? 'rgba(0, 0, 0, 0.1)' : 'none')};
  &:hover {
    background-color: ${(props) => (props?.editModeOn ? 'rgba(0, 0, 0, 0.1)' : 'none')};
  }
`;

export const RightResizeBox = styled.div`
  height: 35px;
  width: 5px;
  position: absolute;
  right: 0;
  cursor: ${(props) => (props?.editModeOn ? 'w-resize' : 'pointer')};
  background-color: ${(props) => (props?.sliding ? 'rgba(0, 0, 0, 0.1)' : 'none')};
  &:hover {
    background-color: ${(props) => (props?.editModeOn ? 'rgba(0, 0, 0, 0.1)' : 'none')};
  }
`;

export const SectorTitleBox = styled.div`
  text-align: center;
  color: black;
  font-weight: 600;
  white-space: pre-wrap;
  line-height: 100%;
  font-size: ${(props) => {
    let fontSize = Math.floor(props?.cardWidth / props?.charLength);
    if (fontSize > 12) fontSize = 12;
    if (fontSize < 7) fontSize = 7;
    if (props?.fullScreenModeOn) fontSize += 6;
    if (fontSize > 16) fontSize = 16;
    return fontSize + 'px;';
  }}
  // text-orientation: ${(props) => (props?.cardWidth < 50 ? 'upright' : 'mixed')};
  // writing-mode: ${(props) => (props?.cardWidth < 50 ? 'vertical-rl' : 'horizontal-tb')};
  margin: 0 auto;
  // letter-spacing: ${(props) => (props?.cardWidth < 50 ? '-2px' : 'auto')};
`;

export const RoleTypeBox = styled.div`
  text-align: center;
  color: #707070;
  background-color: ${(props) => (props?.roleTypeName === 'EXE' ? '#b51200' : '#539441')};
  height: 6px;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
`;

export const DragOverlay = styled.div`
  width: calc(100% - 10px);
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  position: absolute;
  z-index: 998;
`;

export const WarningSymbol = styled.div`
  visibility: ${(props) => (props?.fullScreenModeOn ? 'hidden' : 'visible')};
  width: 14px;
  height: 14px;
  position: absolute;
  top: ${(props) => (props?.duration <= 1 ? '1px' : '5px')};
  right: ${(props) => (props?.duration <= 1 ? '4px' : '7px')};
  color: ${(props) => props?.color};
  line-height: 10px;
  z-index: 999;
`;

export const StartTimeText = styled.div`
  visibility: ${(props) => (props?.fullScreenModeOn || props?.length < 1 ? 'hidden' : 'visible')};
  position: absolute;
  height: 10px;
  font-size: ${(props) => (props?.length === 0.5 ? '8px' : '9px')};
  line-height: ${(props) => (props?.length === 0.5 ? '8px' : '9px')};;
  pointer-events: none;
  width: 35px;
  text-align: center;
  left: -12px;
  top: 13px;
  // background-color: #ffffc9;
  z-index: 1;
  transform: rotate(-90deg);
  // display: ${(props) => (props?.length === 0.5 ? 'none' : 'auto')};
`;

export const EndTimeText = styled.div`
  visibility: ${(props) => (props?.fullScreenModeOn || props?.length < 1 ? 'hidden' : 'visible')};
  position: absolute;
  height: 10px;
  width: 35px;
  font-size: ${(props) => (props?.length === 0.5 ? '8px' : '9px')};
  line-height: ${(props) => (props?.length === 0.5 ? '8px' : '9px')};;
  pointer-events: none;
  // background-color: #ffd7c9;
  text-align: center;
  right: -13px;
  bottom: 13px;
  z-index: 3;
  transform: rotate(90deg);
  // display: ${(props) => (props?.length === 0.5 ? 'none' : 'auto')};
`;

export const SectorOpeningTimeText = styled.div`
  color: red;
  font-weight: 600;
  position: absolute;
  margin-left: 3px;
  margin-top: -18px;
  font-size: 12px;
  background-color: yellow;
  border-radius: 2px;
  padding: 1px;
`;
